import {
  CLAIMFORMS_GAP,
  currentRightsholderLocalStorageKey, NOTIFICATIONS_PAGE_GAP,
  RIGHTS_PAGE_GAP,
  RIGHTSHOLDERS_PAGE_GAP,
  STATEMENTS_PAGE_GAP
} from "@/plugins/store/constants";
import discreteListEntiny from "@/plugins/store/discreteListEntiny";
import without from "@/utils/without";
import loFind from 'lodash/find'

const getCachedCurrentRHs = () => {
  const defaultValue = {};
  try {
    const parsed = JSON.parse(localStorage.getItem(currentRightsholderLocalStorageKey))
    return (parsed && typeof parsed === 'object') ? parsed : defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

const mutations = {
  SET_LOADING(state, value) {
    state.isLoading = value
  },
  SET_INITIALIZED(state, value) {
    state.isInitialized = value
  },
  SET_LOCALE(state, value) {
    state.locale = value
  },
  SET_AUTH(state, value) {
    state.authenticated = Boolean(value);
  },
  SET_USER_DATA(state, {user, rightsholders}) {
    state.user = user;

    const currentRHs = getCachedCurrentRHs();
    const currentRHId = currentRHs[user.email] || null
  
    if (user && user.isadmin) {
      state.currentRightsholderId = currentRHId
    } else if (loFind(rightsholders, ['bol', currentRHId])) {
      state.currentRightsholderId = currentRHId
    } else {
      state.currentRightsholderId = null
    }

  },
  SET_USER_SETTINGS(state, settings) {
    state.settings = settings;
  },

  SET_NOTIFICATIONS_POLLING_INTERVAL(state,interval) {
    state.notificationsPollingInterval = interval
  },

  CLEAR_NOTIFICATIONS (state) {
    state.notifications = discreteListEntiny();
  },

  APPEND_NOTIFICATIONS(state, ntfList) {
    state.notifications.list = state.notifications.list ? state.notifications.list.concat(ntfList) : ntfList;
    state.notifications.pagesLoaded += 1;
    state.notifications.finished = ntfList.length < NOTIFICATIONS_PAGE_GAP;
  },

  UPDATE_POLLED_NOTIFICATIONS(state, ntfList) {
    state.notifications.list = ntfList.concat(state.notifications.list.filter(({id}) => !ntfList.some((ntf) => ntf.id === id)));
  },

  MARK_NOTIFICATION_READ(state, mId) {
    state.notifications.list.find(({id}) => id === mId).isRead = true;
  },

  APPEND_RIGHTSHOLDERS(state, list) {

    // Needed to display current RH in dropdown if this RH is out of first N
    if (state.currentRightsholderData) {
      if (list.find((rh) => rh.id === state.currentRightsholderData.id)) {
        state.currentRightsholderData = list.find((rh) => rh.id === state.currentRightsholderData.id);
      } else {
        list.push(state.currentRightsholderData);
      }
    }
    state.rightsholders.list = state.rightsholders.list ? state.rightsholders.list.concat(list) : list;
    state.rightsholders.pagesLoaded += 1;
    state.rightsholders.finished = list.length < RIGHTSHOLDERS_PAGE_GAP;

  },
  SET_CURRENT_RH(state, id) {

    const currentRHs = getCachedCurrentRHs();
    currentRHs[state.user.email] = id;

    localStorage.setItem(currentRightsholderLocalStorageKey, JSON.stringify(currentRHs));
    state.currentRightsholderId = id;
  },
  SET_CURRENT_RH_DATA(state, data) {
    state.currentRightsholderData = data;
  },

  CLEAR_STATEMENTS(state) {
    state.statements = discreteListEntiny();
  },
  APPEND_STATEMENTS(state, list) {
    state.statements.list = state.statements.list === null ? list : state.statements.list.concat(list);
    state.statements.pagesLoaded += 1;
    state.statements.finished = !(list.length === STATEMENTS_PAGE_GAP);
  },

  CLEAR_RIGHTS(state) {
    state.rights = discreteListEntiny()
  },

  APPEND_RIGHTS_LIST(state, {list: items, totalCount = null}) {
    if (state.rights.list === null) {
      state.rights.list = items;
    } else {
      state.rights.list = state.rights.list.concat(items);
    }
    state.rights.pagesLoaded += 1;
    state.rights.finished = !(items.length === RIGHTS_PAGE_GAP);
    state.rights.totalCount = totalCount;

  },

  CLEAR_UNCLAIMED_RIGHTS_LIST(state) {
    state.unclaimed = discreteListEntiny();
  },

  APPEND_UNCLAIMED_RIGHTS_LIST(state, {list, totalCount = null}) {
    state.unclaimed.list = state.unclaimed.list ? state.unclaimed.list.concat(list) : list;
    state.unclaimed.pagesLoaded += 1;
    state.unclaimed.finished = !(list.length === RIGHTS_PAGE_GAP);
    state.unclaimed.totalCount = totalCount;
  },

  CLEAR_STAGING_ROWS(state) {
    state.staging = discreteListEntiny();
  },

  APPEND_STAGING_ROWS (state, {list, totalCount = null}) {
    state.staging.list = (state.staging.list || []).concat(list);
    state.staging.pagesLoaded += 1;
    state.staging.finished = (list.length < RIGHTS_PAGE_GAP);
    state.staging.totalCount = totalCount;
  },

  REMOVE_STAGING_ROW(state, row) {
    state.staging.list = without(state.staging.list, row);
  },

  CLEAR_CLAIMFORMS(state) {
    state.claimforms = discreteListEntiny();
  },

  APPEND_CLAIMFORMS(state, {list, totalCount = null}) {
    state.claimforms.list = (state.claimforms.list || []).concat(list);
    state.claimforms.pagesLoaded += 1;
    state.claimforms.finished = (list.length < CLAIMFORMS_GAP);
    state.claimforms.totalCount = totalCount;
  },

  REMOVE_CLAIMFORM(state, item) {
    state.claimforms.list =  without(state.claimforms.list, item);
  },

  SET_HOME_CONTENT(state, item) {
    state.homeContent = item
  },

  SET_START_CONTENT(state, item) {
    state.startContent = item
  },

  SET_LOGIN_CONTENT(state, item) {
    state.loginContent = item
  },

  SET_DOCUMENT_CONTENT(state, item) {
    state.documentContent = item
  },

  SET_DIALOG_CONTENT(state, item) {
    state.dialogContent = item
  }

}

export default mutations
